var React = require('react');

function Alarm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.1493 6.06485L23.427 0.0820312L21.5418 2.45346L28.2641 8.43628L30.1493 6.06485ZM9.51474 2.45346L7.64418 0.0820312L0.921875 6.04935L2.80704 8.42078L9.51474 2.45346ZM16.2663 9.59875H14.0742V18.8985L21.0157 23.3158L22.1118 21.4094L16.2663 17.736V9.59875ZM15.5356 3.39893C8.27257 3.39893 2.38325 9.64525 2.38325 17.3485C2.38325 25.0518 8.25796 31.2981 15.5356 31.2981C22.7986 31.2981 28.6879 25.0518 28.6879 17.3485C28.6879 9.64525 22.7986 3.39893 15.5356 3.39893ZM15.5356 28.1982C9.88008 28.1982 5.30599 23.3468 5.30599 17.3485C5.30599 11.3502 9.88008 6.49884 15.5356 6.49884C21.1911 6.49884 25.7652 11.3502 25.7652 17.3485C25.7652 23.3468 21.1911 28.1982 15.5356 28.1982Z","fill":"black"}));
}

Alarm.defaultProps = {"width":"31","height":"32","viewBox":"0 0 31 32","fill":"none"};

module.exports = Alarm;

Alarm.default = Alarm;
